import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ModernLoginScreen } from './ModernLoginScreen';
import { useAuth } from '../contexts/AuthContext';
import { isMobileViewport } from '../utils/rmQrPayload';

export function LoginDemo() {
  const navigate = useNavigate();
  const { user, isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthenticated && user) {
      navigate(isMobileViewport() ? '/m' : '/dashboard', { replace: true });
    }
  }, [isAuthenticated, user, navigate]);

  if (isAuthenticated && user) {
    return null;
  }

  return <ModernLoginScreen />;
}
